import { render, staticRenderFns } from "./Page-without-sidebar.vue?vue&type=template&id=616aeb42&"
import script from "./Page-without-sidebar.vue?vue&type=script&lang=js&"
export * from "./Page-without-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports